import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import { styled } from "@mui/material/styles";
import { LayoutElementSizes } from "../../../../common/ui";

interface Props extends MuiAppBarProps {
	open?: boolean;
}

/**
 * AppBarContainer contains the GreenRouter UI application top bar.
 * This application bar is fixed at the top of the screen (does not scroll).
 */
const AppBarContainer = styled(MuiAppBar, {
	shouldForwardProp: (props) => props !== "open",
})<Props>(({ theme, open }) => ({
	zIndex: theme.zIndex.drawer + 1,
	transition: theme.transitions.create(["width", "margin"], {
		easing: theme.transitions.easing.easeOut,
		duration: theme.transitions.duration.leavingScreen,
	}),
	...(open && {
		marginLeft: LayoutElementSizes.SideMenuWidth,
		width: `calc(100% - ${LayoutElementSizes.SideMenuWidth}px)`,
		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.easeOut,
			duration: theme.transitions.duration.enteringScreen,
		}),
	}),
}));

export default AppBarContainer;
